import React, { useRef, useEffect, MouseEvent } from 'react';
import { createEmitAndSemanticDiagnosticsBuilderProgram } from 'typescript';

interface CanvasItemProps {
  width: number;
  height: number;
  index: number;
  chartData: any;
}

const CanvasItem = ({
  width,
  height,
  index,
  chartData,
}: CanvasItemProps): JSX.Element => {
  var enterMode = false;
  var exitMode = false;
  var addAnchorMode = false;
  var entryPrice = -1;
  var exitPrice = -1;
  var currentPriceFromMouse = -1;

  var toggleEnterMode = () => {
    enterMode = !enterMode;
  };

  var toggleAddAnchorMode = () => {
    addAnchorMode = !addAnchorMode;
  };

  var toggleExitMode = () => {
    exitMode = !exitMode;
  };

  var handleChartClick = () => {
    console.log('chart clicked');
    console.log('enter mode ' + enterMode);
    console.log('exit mode ' + exitMode);
    console.log('curr price from y ' + currentPriceFromMouse);
    if (enterMode == true && exitMode == false) {
      entryPrice = currentPriceFromMouse;
      enterMode = false;
      exitMode = false;
    }
    if (enterMode == false && exitMode == true) {
      exitPrice = currentPriceFromMouse;
      enterMode = false;
      exitMode = false;
    }
  };

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  var firstResult = chartData['chart']['result'][0];
  var symbol = firstResult['meta']['symbol'];

  var firstQuote = firstResult['indicators']['quote'][0];
  var volumes = firstQuote['volume'];
  var opens = firstQuote['open'];
  var closes: number[] = firstQuote['close'];
  var highs = firstQuote['high'];
  var lows: number[] = firstQuote['low'];
  var timestamps: number[] = firstResult['timestamp'];
  var canvasSaved: boolean = false;

  // console.log("Timestamps: ", timestamps)
  // console.log("Volume: ", volumes)
  // console.log("Open: ", opens)
  // console.log("Close: ", closes)
  // console.log("Highs: ", highs)
  // console.log("Lows: ", lows)

  var priceSectionHeight = height * 0.8;
  var volumeSectionHeight = height * 0.2;
  var candleWidth = width / timestamps.length;
  var chartWidth = width * 0.9;

  var minPrice = Math.min(...lows);
  var maxPrice = Math.max(...highs);
  var maxVolume = Math.max(...volumes);
  // console.log("min=" + minPrice + " max = " + maxPrice)

  var getPriceByY = (y: number) => {
    var percentageFromTop = y / priceSectionHeight;
    var highMinusLow = maxPrice - minPrice;
    return maxPrice - percentageFromTop * highMinusLow;
  };

  var getYByPrice = (pricePoint: number) => {
    //   fun getYValueByPrice(pricePoint: Float): Float {
    //     val lowestPrice: Float = minPrice
    //     val highMinusLow = maxPrice - lowestPrice
    //     val priceMinusLow = pricePoint - lowestPrice
    //     val fromTop = highMinusLow - priceMinusLow
    //     val percentageFromTop = fromTop / highMinusLow
    //     return (percentageFromTop * priceSectionHeight)
    // }
    var highMinusLow = maxPrice - minPrice;
    //console.log("high min low:" + highMinusLow)
    var priceMinusLow = pricePoint - minPrice;
    //console.log("price min low " + priceMinusLow)
    var fromTop = highMinusLow - priceMinusLow;
    //console.log("from top " + fromTop )
    var percentageFromTop = fromTop / highMinusLow;
    //console.log("% from top  " + percentageFromTop )
    //console.log("rett: " + (percentageFromTop * priceSectionHeight))
    return percentageFromTop * priceSectionHeight;
  };

  var drawVolume = (
    ctx: CanvasRenderingContext2D,
    index: number,
    fromLeft: number,
  ) => {
    var volComparedToMaxVol = volumes[index] / maxVolume;

    var volumeYStart = height - volumeSectionHeight;
    var volY =
      volumeYStart +
      (volumeSectionHeight - volComparedToMaxVol * volumeSectionHeight);
    if (volumes[index] > 0) {
      var volLineCenterX = fromLeft + candleWidth / 2;
      // drawLine(
      //     start = Offset(volLineCenterX,
      //         volY.toFloat()
      //     ),
      //     end = Offset(volLineCenterX, size.height),
      //     color = candleColor,
      //     strokeWidth = candleWidth
      // )
      ctx.beginPath();
      ctx.strokeStyle = 'gray';
      ctx.lineWidth = candleWidth;
      ctx.moveTo(volLineCenterX, volY);
      ctx.lineTo(volLineCenterX, height);
      ctx.stroke();
    }
  };

  var drawPrice = (ctx: CanvasRenderingContext2D) => {
    // draw price right side gradient
    const gradient = ctx.createLinearGradient(chartWidth, 0, width, 0); // Horizontal gradient
    gradient.addColorStop(0, 'black'); // Start color (left side)
    gradient.addColorStop(1, 'rgba(100,100,100,0.5)'); // End color (right side)

    ctx.fillStyle = gradient; // Apply the gradient as the fill style
    ctx.fillRect(chartWidth, 0, width, height); // Draw the rectangle

    // start price lines and text
    var priceDiff = maxPrice - minPrice;
    var priceLineInterval = priceDiff / 5;
    for (var i = 0; i < 5; i++) {
      var bottomPrice = minPrice + i * priceLineInterval;
      //console.log("btm pr: " + bottomPrice)
      var yVal = getYByPrice(bottomPrice);
      //console.log("yval : " + yVal)
      // drawLine(
      //     start = Offset(0f, yVal),
      //     end = Offset(chartWidth, yVal),
      //     color = priceLineColor,
      //     pathEffect = pathEffect,
      //     strokeWidth = candleWidth * .1f
      // )
      //nativeCanvas.drawText(bottomPrice.toTwoDecimalString(),  chartWidth, yVal + 30f, priceLinePaint )
      bottomPrice = parseFloat(bottomPrice.toFixed(2));

      //  horizontal price line
      // ctx.beginPath();
      // ctx.setLineDash([3, 3]); // [5, 5] defines a dashed pattern: 5px line, 5px space
       ctx.strokeStyle = 'rgba(255, 165, 0, 1)';
      // ctx.lineWidth = 0.3;
      // ctx.moveTo(0, yVal);
      // ctx.lineTo(width, yVal);
      // ctx.stroke();
      // ctx.setLineDash([]);
      //ctx.fillStyle
      ctx.font = '18px Courier';
      ctx.fillStyle = 'orange';
      // end hor pri line
      ctx.fillText(`${bottomPrice}`, width - 50, yVal + 16, 50);
    }


  };


  function drawPercentageChange(
    ctx: CanvasRenderingContext2D,
    priceTwoDaysAgo: number,
    priceToday: number,
    x: number,
    y: number
  ): void {
    if (priceTwoDaysAgo === 0) {
      throw new Error("The price two days ago cannot be zero.");
    }
  
    // Calculate the percentage change
    const change = ((priceToday - priceTwoDaysAgo) / priceTwoDaysAgo) * 100;
  
    // Determine the color and format
    const color = change >= 0 ? 'green' : 'red';
    const formattedChange = `${change >= 0 ? '+' : ''}${change.toFixed(2)}%`;
  
    // Set text style and color
    ctx.fillStyle = color;
    ctx.font = '22px Arial';
  
    // Draw the text on the canvas
    ctx.fillText(formattedChange, x, y);
  }

  var drawChart = (canvas: HTMLCanvasElement) => {
    const ctx = canvas.getContext('2d');

    var barWidth = chartWidth / timestamps.length;

    if (ctx) {
      ctx.globalAlpha = 1.0;

      ctx.clearRect(0, 0, chartWidth, height);
      ctx.fillStyle = 'black';
      ctx.fillRect(0, 0, chartWidth, height);
      ctx.fill();
      var fromLeft = 0;
      var candleIndex = 0;

      for (const i in timestamps) {
        //console.log("i", i)
        // Draw a circle
        //ctx.beginPath();
        //console.log("closes at i=" + i + " , " + closes[i])
        //console.log("draw c at x=" + barWidth + " y=" + getYByPrice(closes[i]) )
        //ctx.arc(fromLeft, getYByPrice(closes[i]), 4, 0, 2 * Math.PI); // (x, y, radius, startAngle, endAngle)
        //ctx.fillStyle = 'green'; // Fill color
        //ctx.fill();                // Fill the circle
        //ctx.lineWidth = 5;         // Border width
        //ctx.strokeStyle = 'blue';  // Border color
        //ctx.stroke();              // Draw the border
        drawPrice(ctx);
        drawCandle(ctx, candleIndex, fromLeft);
        drawVolume(ctx, candleIndex, fromLeft);
        candleIndex++;
        fromLeft += barWidth;
      }

      drawTopBar(ctx, symbol, closes)

    }
  };

  var drawAvwapFromDaysBack = (
    daysBack: number,
    ctx: CanvasRenderingContext2D,
  ) => {
    var candlesBack = daysBack;

    if (candlesBack > 0 && candlesBack <= timestamps.length) {
      var totalVolume = 0;
      var totalPriceCumulative = 0;
      var avWapX = chartWidth - candlesBack * candleWidth;
      var candleCount = timestamps.length;
      var daysBackVolumes = volumes.slice(
        candleCount - candlesBack,
        candleCount,
      );
      var daysBackCloses = closes.slice(candleCount - candlesBack, candleCount);

      var lastAvWapPrice = 0;
      var currCandle: number = -1;
      var prevCandle: number = -1;
      var prevCumulative: number = -1;
      var prevTotalVolume: number = -1;

      var avwappIndex = 0;
      for (var daysBackVolume of daysBackVolumes) {
        currCandle = daysBackVolume;
        prevTotalVolume = totalVolume;
        totalVolume += daysBackVolume;
        var priceValue = 0.0;
        priceValue = daysBackCloses[avwappIndex];

        if (prevCandle == null) {
          prevCumulative = priceValue * daysBackVolume;
        } else {
          prevCumulative = totalPriceCumulative;
        }
        totalPriceCumulative += priceValue * daysBackVolume;
        var avWpPrice = totalPriceCumulative / totalVolume;
        avWapX += candleWidth;
        if (prevCandle != null) {
          var prevAvWapPrice = prevCumulative / prevTotalVolume;
          if (prevAvWapPrice > 0 && avWapX > 0) {
            ctx.beginPath();
            ctx.strokeStyle = 'magenta';
            ctx.lineWidth = candleWidth * 0.25;
            ctx.moveTo(avWapX - candleWidth, getYByPrice(prevAvWapPrice));
            ctx.lineTo(avWapX, getYByPrice(avWpPrice));
            ctx.stroke();
          }
        }
        lastAvWapPrice = avWpPrice;
        prevCandle = currCandle;
        avwappIndex++;
      }

      if (lastAvWapPrice > 0) {
        lastAvWapPrice = (lastAvWapPrice * 100) / 100;
        //nativeCanvas.drawText("AVWAP: " + lastAvWapPrice, 40f, 150f, whitePaint )
        ctx.font = '20px Arial';
        ctx.fillStyle = 'green';
        ctx.fillText('AVWAP: ' + parseFloat(lastAvWapPrice.toFixed(2)), 30, 40);
      }
    }
  };

  function drawTopBar(ctx: CanvasRenderingContext2D, symbol: any, closes: number[]) {
    //ctx.fillStyle = '#f0f0f0'
      //ctx.fillRect(0, 0, width, height)
      ctx.font = '22px Arial';
      ctx.fillStyle = 'yellow';
      ctx.fillText(`${symbol}`, 10, 20);
     

      // draw last price

      if (closes.length > 1) {
        var lastClosingPrice = closes[closes.length - 1];
        var secondToLastClosingPrice = closes[closes.length - 2];
        lastClosingPrice = parseFloat(lastClosingPrice.toFixed(2));
        ctx.fillText(`$${lastClosingPrice}`, 100, 20);
        drawPercentageChange(
          ctx,
          secondToLastClosingPrice,
          lastClosingPrice,
          200,
          20,
        );
      }
}

  var drawCandle = (
    ctx: CanvasRenderingContext2D,
    index: number,
    fromLeft: number,
  ) => {
    var candleColor = 'green';
    var candleTopOpenOrClose = closes[index];
    var candleBottomOpenOrClose = opens[index];
    if (opens[index] >= closes[index]) {
      candleColor = 'red';
      candleTopOpenOrClose = opens[index];
      candleBottomOpenOrClose = closes[index];
    }

    var rectTop = getYByPrice(candleTopOpenOrClose!!);
    var rectBottom = getYByPrice(candleBottomOpenOrClose!!);

    var wickTopY = getYByPrice(highs[index]);
    var wickBottomY = getYByPrice(lows[index]);

    var wickWidth = candleWidth / 3;
    var wickX = fromLeft + candleWidth / 2;
    //var candleRectOffset = Offset(topLeftOffset.x, rectTop)

    ctx.strokeStyle = 'grey';
    ctx.lineWidth = wickWidth;

    //ctx.beginPath()
    ctx.beginPath();
    ctx.moveTo(wickX, wickTopY);
    ctx.lineTo(wickX, wickBottomY);
    ctx.stroke();

    // drawLine(
    //     color = Color.LightGray,
    //     start = Offset(wickX, wickTopY),
    //     end = Offset(wickX, wickBottomY),
    //     strokeWidth = wickWidth
    // )

    ctx.beginPath();
    ctx.fillStyle = candleColor;
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'black';
    ctx.rect(fromLeft, rectTop, candleWidth, rectBottom - rectTop);
    ctx.fill();

    // drawRect(color = candleColor,
    //     topLeft = candleRectOffset,
    //     size = Size(candleWidth,
    //          rectBottom - rectTop)
    // )
  };

  useEffect(() => {
    const canvas = canvasRef.current; // Valid reference here
    if (canvas) {
      drawChart(canvas);
    }
  }, [width, height, index]);

  const handleMouseMove = (e: MouseEvent<HTMLCanvasElement>) => {
    const canvas = canvasRef.current;
    if (canvas) {
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const ctx = canvas.getContext('2d');

      if (ctx) {
        // ctx.clearRect(0, 0, width, height);
        // ctx.fillStyle = '#f0f0f0';
        // ctx.fillRect(0, 0, width, height);
        // ctx.font = '16px Arial';
        // ctx.fillStyle = '#000';
        // ctx.fillText(`Mouse: ${x}, ${y}`, 10, 20);

        ctx.clearRect(0, 0, width, height);

        drawChart(canvas);

        if (entryPrice != -1) {
          ctx.strokeStyle = 'green';
          ctx.lineWidth = 2;
          var entryY = getYByPrice(entryPrice);
          ctx.moveTo(0, entryY);
          ctx.lineTo(chartWidth, entryY);
          ctx.stroke();
        }

        if (exitPrice != -1) {
          ctx.strokeStyle = 'red';
          ctx.lineWidth = 2;
          var exitY = getYByPrice(exitPrice);
          ctx.moveTo(0, exitY);
          ctx.lineTo(chartWidth, exitY);
          ctx.stroke();
        }

        ctx.beginPath();
        ctx.lineWidth = candleWidth * 0.25;
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();

        ctx.beginPath();
        ctx.lineWidth = candleWidth * 0.25;
        if (enterMode) {
          ctx.strokeStyle = 'green';
        } else if (exitMode) {
          ctx.strokeStyle = 'red';
        } else {
          ctx.strokeStyle = 'yellow';
        }

        ctx.moveTo(0, y);
        ctx.lineTo(chartWidth, y);
        ctx.stroke();
        currentPriceFromMouse = getPriceByY(y);

        var daysBack = (chartWidth - x) / candleWidth;
        drawAvwapFromDaysBack(daysBack, ctx);

        // curr price rect
        ctx.fillStyle = 'black';
        ctx.fillRect(width - 50, y, width - chartWidth, 25);

        //price line
        var price = getPriceByY(y);
        price = parseFloat(price.toFixed(2));
        ctx.font = '24px courier';
        ctx.fillStyle = 'yellow';
        ctx.fillText(`${price}`, width - 50, y + 16, 50);
      }
    }
  };

  return (
    <div>
      {/*
      <button onClick={toggleAddAnchorMode}>Add Anchor</button>
      <button onClick={toggleEnterMode}>Enter</button>
      <button onClick={toggleExitMode}>Exit</button>
      */}

      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{ border: '1px solid #ccc' }}
        onClick={handleChartClick}
        onMouseMove={handleMouseMove}
      />
    </div>
  );
};

export default CanvasItem;


